import React from 'react'

import { ButtonStatContextProvider } from 'common/builder/components/chart/FlowChart/contexts/ButtonStatContext'
import { FlowChartContentNode } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartContentNode'
import { useFlowChartNodeContext } from 'common/builder/hooks/useFlowChartNodeContext'

export const useContentNodeButtonStatProviderValue = (): React.ComponentProps<
  typeof ButtonStatContextProvider
>['value'] => {
  const { node, readonly, noStat } = useFlowChartNodeContext()
  const flowChartNode = node as FlowChartContentNode

  return {
    totalUsers: flowChartNode?.data?.stats?.deliveredUniqueUsers || 0,
    showButtonStats: readonly && !noStat,
  }
}
